var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('table-page',{ref:"childTable",attrs:{"pageData":_vm.pageData},on:{"btnclick":_vm.bthClick}}),_vm._v(" "),_c('UPDATE',{ref:"childUpdate",attrs:{"updateData":_vm.updateData},on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }